import { SessionData, WellList, BiTubeWellList } from './Reducer'

export const EmptyWellPlate: WellList = {
  __typename: ' ',
  additionalComments: '',
  amount: '',
  baseCount: 0,
  category: '',
  column: '',
  comments: '',
  concentration: '',
  countryCode: '',
  epsilon: 0,
  excessMaterial: false,
  fiveMod: '',
  flag: 0,
  format: '',
  gcContent: '',
  id: 0,
  isOverridden: false,
  listError: [],
  listWarning: [],
  meltingTemparature: '',
  molecularWeight: '',
  name: '',
  oligoId: 0,
  orderItemId: ' ',
  other: '',
  packageType: '',
  pageNo: 0,
  primerDimer: '',
  productType: '',
  purification: '',
  row: '',
  scale: '',
  secondaryStructure: '',
  sequence: '',
  shipping: '',
  technicalSequence: '',
  terms: false,
  threeMod: '',
  tubes: 1,
  wellType: 0,
}

export const EmptyDuplexWell: BiTubeWellList = {
  __typename: '',
  additionalComments: '',
  amount: '',
  antisenceBaseCount: 0,
  antisenceFiveMod: '',
  antisenceName: '',
  antisenceSequence: '',
  antisenceThreeMod: '',
  antisenseGcContent: '',
  antisenseMeltingTemparature: '',
  antisenseMolecularWeight: '',
  antisensePrimerDimer: '',
  antisenseSecondaryStructure: '',
  autoGenerateOligo: false,
  autoValidation: false,
  baseCount: 0,
  column: '',
  comments: '',
  concentration: '',
  countryCode: '',
  customerAntisenseOverHang: '',
  customerOverhang: '',
  fiveMod: '',
  format: '',
  gcContent: '',
  id: 0,
  isOverridden: false,
  listError: [],
  listWarning: [],
  meltingTemparature: '',
  molecularWeight: '',
  name: '',
  orderItemId: '',
  packageType: '',
  pageNo: 0,
  primerDimer: '',
  productType: '',
  purification: '',
  row: '',
  scale: '',
  secondaryStructure: '',
  senseNameCheck: false,
  sequence: '',
  shipping: '',
  technicalAntisenceSequence: '',
  technicalSequence: '',
  terms: false,
  threeMod: '',
  tubes: 0,
}

export const EmptyStatePlate: SessionData = {
  __typename: '',
  amount: '',
  applyToAll: false,
  biTubeWellList: [EmptyDuplexWell],
  category: '',
  channelType: 0,
  concentration: '',
  countOfWells: 0,
  countryCode: '',
  daughterPlateCount: '',
  format: '',
  isAmountSelected: false,
  isCSR: false,
  isCSRSupervisor: false,
  isConcentrationOther: false,
  isConcentrationSelected: false,
  isOverridden: false,
  isPackageTypeOther: false,
  isShippingOverridden: false,
  isSpecificationsOverridden: false,
  material: '',
  maxAmount: '',
  minAmount: '',
  packageType: '',
  pageNo: 0,
  plateCopiesRange: '',
  plateId: 1,
  plateName: 'New Plate',
  plateNameError: [],
  plateType: '',
  productType: '',
  purification: '',
  researcher: '',
  researcherNameError: [],
  scale: '',
  selectedPackageType: '',
  shipping: '',
  stockPlate: '',
  totalBaseCount: 0,
  wellList: [EmptyWellPlate],
  wellType: 0,
}
